import { Utils } from "../../assets/js/helpers/utils";
import { StoreManager } from "../../assets/js/helpers/store";
import { Ajax } from "../../assets/js/helpers/ajax";
import { Modal } from "bootstrap";
import { ZEvents } from "../../assets/js/helpers/events";

export class SearchOverlay {

    cssClass = "c-searchoverlay";
    isOpen = false;
    isTyping = false;
    typingFieldSelector = `[data-search-input]`;
    tplSearchResult = null;
    searchResultsStage = null;
    noResultsLabel = null;
    loader = null;
    searchEndPoint = "";
    lockSearch = false;
    searchStartDelay = 800;
    
    constructor(el = null) {
        this.el = el;
        this.searchEndPoint = this.el.getAttribute("data-search-endpoint");
        this.loader = this.el.querySelector("[data-loader]");
        this.tplSearchResult = this.el.querySelector("[data-search-result-tpl]").innerHTML;
        this.searchResultsStage = this.el.querySelector("[data-search-results]");
        this.noResultsLabel = this.el.querySelector("[data-no-results]");
        this.init();
        StoreManager.setState("searchOverlayOpen", false);
    }

    init(){

        var currentComponent = this;
        var searchInput = this.el.querySelector(this.typingFieldSelector);

        this.el.addEventListener("shown.bs.modal", () => {
            currentComponent.isOpen = true;
            StoreManager.setState("searchOverlayOpen", true);
            searchInput.focus();
        });
        this.el.addEventListener("hide.bs.modal", () =>{
            currentComponent.el.classList.remove(`${currentComponent.cssClass}--typing`);
            currentComponent.isOpen = false;
            StoreManager.setState("searchOverlayOpen", false );
        });
        
        document.addEventListener(`${Utils.getVarNS()}.offcanvas.shown`, () =>{
            if( StoreManager.getState("searchOverlayOpen") == true ){
                Modal.getInstance(currentComponent.el).hide();
            }
        });

        searchInput.addEventListener("keyup", (e) => {
            var target = e.currentTarget;

            // Ignore keys that are not useful for the query
            if (!e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.key !== 'Tab' &&
            (e.keyCode < 37 || e.keyCode > 40) && e.keyCode !== 13) {
                if( target.value !== '' ){
                    if( !this.lockSearch ){
                        this.lockSearch = true;
                        setTimeout(() => {
                            currentComponent.el.isTyping = true;
                            currentComponent.el.classList.add(`${currentComponent.cssClass}--typing`);
                            currentComponent.el.classList.add(`${currentComponent.cssClass}--searching`);
                            this.noResultsLabel.classList.remove("--show");
                            this.loader.classList.add("--active");

                            //Set get params for URL
                            let endpointURL = this.searchEndPoint;
                            let searchParams = new URLSearchParams();
                            searchParams.set("s", target.value);
                            let newParams = searchParams.toString();
                            endpointURL += (endpointURL.indexOf("?") === -1 ? "?" : "&") + newParams;

                            Ajax.get(endpointURL).then(response => {
                                this.loader.classList.remove("--active");
                                currentComponent.el.classList.remove(`${currentComponent.cssClass}--searching`);
                                this.searchResultsStage.innerHTML = "";
                                this.noResultsLabel.classList.remove("--show");
                                if( response.results.length > 0 ){
                                    response.results.forEach( (element, index) => {
                                        var searchResult = this.tplSearchResult;
                                        searchResult = searchResult.replaceAll("%TITLE%", element.title);
                                        searchResult = searchResult.replaceAll("%EYELET%", element.eyelet);
                                        searchResult = searchResult.replaceAll("%IMGPLACEHOLDER%", element.img);
                                        searchResult = searchResult.replaceAll("data-hold-src", "src");
                                        searchResult = searchResult.replaceAll("%URL%", element.url);
                                        this.searchResultsStage.innerHTML += searchResult;
                                    });
                                }else{
                                    this.noResultsLabel.classList.add("--show");
                                }
                                this.lockSearch = false;
                            });
                        }, currentComponent.searchStartDelay);
                    }
                }else{
                    currentComponent.el.isTyping = false;
                }
            }
        });

    }

}